import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton, BaasicConfirmModal,  } from 'core/components';

function FacilityOrderTemplateItemNewFlowCalculationModalTemplate({ facilityOrderTemplateItemNewFlowCalculationModalStore, t }) {
    const {
        facilityOrderTemplateItem,
        updateResource,
        modalParams,
        calculateQuantity,
        isEnteredTotalWrong,
        editItem,
        recalculateQuantity,
        isRecalculateDisabled,
        errorMessage,
        handleKeyDown,
        facilityOrderTemplateItemRef,
        calculationConfirmModal,
        isSavingResource
    } = facilityOrderTemplateItemNewFlowCalculationModalStore;

    return (
        <section>
            <div className="modal__header" style={{ display: "block" }}>
                <div>
                    <h3 className='modal__header__title u-mar--bottom--tny'>Enteral Formula Calculation</h3>
                </div>
                <div className="u-mar--bottom--med">
                    <p className='type--sml type--wgt--medium type--opaque'>The calculation is based off:</p>
                    <p className='type--sml type--wgt--medium type--opaque'>{"1) mL x Freq = Total mL"}</p>
                    <p className='type--sml type--wgt--medium type--opaque'>{"2) Total mL x caloric density of formula = Total Calories"}</p>
                    <p className='type--sml type--wgt--medium type--opaque'>You can either put in 1 field on either side of the equation or both fields on the left side of the equation</p>
                </div>
            </div>

            <div className="modal__body">
                <h4 className='message message--med message--primary type--wgt--bold type--sml u-mar--bottom--xsml'>{facilityOrderTemplateItem.product.description}</h4>
                <table>
                    <colgroup>
                        <col />
                        <col />
                        <col />
                        <col />
                        <col />
                    </colgroup>
                    <tbody>
                        <tr>
                            <td>
                                <div className="u-mar--right--sml">
                                    <div className='form__group__label'>mL</div>
                                    <input className="input input--base"
                                        onClick={(e) => e.target.select()}
                                        onChange={(e) => { editItem(e.target.value, 'mlph', 'itemMlph'); }}
                                        onBlur={() => { calculateQuantity('itemMlph', 'mlph', 'frequency'); }}
                                        value={facilityOrderTemplateItem.mlph}
                                        ref={facilityOrderTemplateItemRef.mlph}
                                        onKeyDown={(e) => handleKeyDown(e)}
                                        disabled={isSavingResource}
                                        // type="number"
                                        // min="0"
                                    />

                                </div>
                            </td>
                            <td>
                                <div className="u-mar--right--sml">
                                    <div className='form__group__label'>Freq</div>
                                    <input className="input input--base"
                                        onClick={(e) => e.target.select()}
                                        onChange={(e) => { editItem(e.target.value, 'frequency', 'itemFrequency'); }}
                                        onBlur={() => { calculateQuantity('itemFrequency', 'frequency','itemMls'); }}
                                        value={facilityOrderTemplateItem.frequency}
                                        ref={facilityOrderTemplateItemRef.frequency}
                                        onKeyDown={(e) => handleKeyDown(e)}
                                        disabled={isSavingResource}
                                        // type="number"
                                        // min="0"
                                    />
                                </div>
                            </td>
                            <td className="u-align--v--bottom">
                                <div className="u-mar--right--sml">
                                    <i className="u-icon u-icon--sml u-icon--equal-sign u-mar--bottom--sml"></i>
                                </div>
                            </td>
                            <td>
                                <div className="u-mar--right--sml">
                                    <div className='form__group__label'>Total mL</div>
                                    <input className="input input--base"
                                        onClick={(e) => e.target.select()}
                                        onChange={(e) => { editItem(e.target.value, 'itemMls', 'itemMls'); }}
                                        onBlur={() => { calculateQuantity('itemMls', 'itemMls', 'itemCals'); }}
                                        value={facilityOrderTemplateItem.itemMls}
                                        ref={facilityOrderTemplateItemRef.itemMls}
                                        onKeyDown={(e) => handleKeyDown(e)}
                                        disabled={isSavingResource}
                                        // type="number"
                                        // min="0"
                                    />
                                </div>
                            </td>
                            <td>
                                <div className='form__group__label'>Total Calories</div>
                                    <input className="input input--base"
                                        onClick={(e) => e.target.select()}
                                        onChange={(e) => { editItem(e.target.value, 'itemCals', 'itemCals'); }}
                                        onBlur={() => { calculateQuantity('itemCals', 'itemCals', 'mlph'); }}
                                        value={facilityOrderTemplateItem.itemCals}
                                        ref={facilityOrderTemplateItemRef.itemCals}
                                        onKeyDown={(e) => handleKeyDown(e)}
                                        disabled={isSavingResource}
                                        // type="number"
                                        // min="0"
                                    />
                            </td>
                            <td className="u-align--v--bottom">
                                <button disabled={isRecalculateDisabled || isSavingResource} onClick={() => recalculateQuantity()} className="btn btn--base btn--light u-align--v--bottom u-mar--left--xsml">
                                    <i className="u-icon u-icon--med u-icon--refresh2" ></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                {
                    isEnteredTotalWrong &&
                    <div className="message message--warning message--med u-mar--top--xsml">
                        <p>{errorMessage}</p>
                    </div>
                }
            </div>
            <div className='modal__footer is-right'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                />
                <BaasicButton
                    className='btn btn--med btn--primary'
                    label="Apply"
                    onClick={() => updateResource()}
                    disabled={isSavingResource}
                    rotate icon={
                        isSavingResource 
                            ? "u-icon u-icon--xmed u-icon--sync u-rotate--login"
                            : 'u-display--none'
                    }
                />
            </div>

            <BaasicConfirmModal modalParams={calculationConfirmModal}/>
        </section>
    )
}

FacilityOrderTemplateItemNewFlowCalculationModalTemplate.propTypes = {
    facilityOrderTemplateItemNewFlowCalculationModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(FacilityOrderTemplateItemNewFlowCalculationModalTemplate);
